// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"ExcelDragDrop_loadingScreen__xWDAB"};